module.exports = __webpack_public_path__ + "img/Fußspuren.227635aa.svg";